import React, { useState } from "react";
import { TextInput, Button, Dropdown } from "../indexComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

function AddTeamTaskForm({ cancelBtnOnClick, onTaskAdded, teamId, teamInfo }) {
  const [taskName, setTaskName] = useState("");
  const [teamClients, setTeamClients] = useState(teamInfo.Team_Clients);
  const [teamMembers, setTeamMembers] = useState(teamInfo.Team_Members);

  const clientsOptions = [
    ...teamClients.map((client) => ({
      value: client.id,
      label: client.name + " " + client.company,
    })),
  ];

  const membersOptions = [
    {
      value: `Tous les membres ${teamMembers.map((member) => member.username)}`,
      label: "Tous les membres",
    },
    ...teamMembers.map((client) => ({
      value: client.username,
      label: client.username,
    })),
  ];

  const [steps, setSteps] = useState([""]);

  const handleStepChange = (index, event) => {
    const newSteps = [...steps];
    newSteps[index] = event.target.value;
    setSteps(newSteps);
  };

  const addStep = () => {
    setSteps([...steps, ""]);
  };

  const [selectedClient, setSelectedClient] = useState("");

  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption ? selectedOption.value : null);
  };
  const [selectedMembers, setSelectedMembers] = useState([]); // initialiser comme un tableau vide

  const handleMemberChange = (selectedOptions) => {
    setSelectedMembers(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    console.log("YEAHHHHHHHHHHHHHHH", {
      clientId: selectedClient,
      name: taskName,
      steps: steps,
      assignTo: selectedMembers,
    });

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/team-task/${teamId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          clientId: selectedClient,
          name: taskName,
          steps: steps,
          assignTo: selectedMembers,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to add task");
    }

    setSelectedClient("");
    setSelectedMembers("");
    setSteps([]);
    setTaskName("");
    onTaskAdded();
  };

  return (
    <div id="AddTaskForm">
      <form>
        <TextInput
          labelText="Nom de la tache"
          name="tache_title"
          type="text"
          placeholder=""
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
        <Dropdown
          options={clientsOptions}
          placeholder="Sélectioner un client"
          onChange={handleClientChange}
          value={selectedClient.value}
        />
        <Dropdown
          isMulti={true}
          options={membersOptions}
          placeholder="Assigner à"
          onChange={handleMemberChange}
          value={selectedMembers.value}
        />
        <div>
          <h3 className="step-task-title">Étapes de la tâche :</h3>
          {steps.map((step, index) => (
            <div key={index}>
              <TextInput
                labelText={`Étape ${index + 1} :`}
                type="text"
                value={step}
                onChange={(e) => handleStepChange(index, e)}
              />
            </div>
          ))}
          <div className="centered">
            <button type="button" onClick={addStep} className="add-step-btn">
              <FontAwesomeIcon icon={faPlus} />
            </button>
          </div>
        </div>

        <div className="btn-container">
          <Button
            className="cancel-add-task-btn"
            onClick={cancelBtnOnClick}
            text="Annuler"
          />
          <Button
            className="send-task-btn"
            type="submit"
            text="Confirmer"
            onClick={handleSubmit}
          />
        </div>
      </form>
    </div>
  );
}

export default AddTeamTaskForm;
